<p-dialog [(visible)]="awaitingTerminalPayment" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '380px'}">
  <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:32px 24px; text-align:center;">
    <i class="pi pi-spin pi-spinner" style="font-size:3rem; color:#2563eb;"></i>
    <div style="font-size:1.2rem; font-weight:700; color:#111827;">Waiting for Terminal</div>
    <div style="font-size:0.95rem; color:#6b7280;">Please complete the payment on the card reader.</div>
    <button pButton pRipple type="button"
      class="p-button p-button-secondary"
      style="min-width:160px;"
      (click)="cancelTerminalPayment()"><span class="p-button-icon p-button-icon-left pi pi-times" aria-hidden="true"></span><span class="p-button-label">Cancel Payment</span></button>
    </div>
  </p-dialog>

  <p-dialog [(visible)]="showTerminalBusyDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
    <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
      <div style="width:60px; height:60px; border-radius:50%; background:#fff7ed; display:flex; align-items:center; justify-content:center;">
        <i class="pi pi-exclamation-triangle" style="font-size:2rem; color:#d97706;"></i>
      </div>
      <div style="font-size:1.2rem; font-weight:700; color:#111827;">Terminal In Use</div>
      <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">This terminal is currently processing another transaction. Would you like to wait for it to finish, or clear the terminal and retry?</div>
    </div>
    <ng-template #footer>
      <div style="display:flex; justify-content:center; gap:10px; padding-bottom:8px;">
        <button pButton pRipple type="button"
          class="p-button p-button-secondary p-button-outlined"
          style="min-width:120px;"
          (click)="waitForTerminal()"><span class="p-button-icon p-button-icon-left pi pi-clock" aria-hidden="true"></span><span class="p-button-label">Wait</span></button>
          <button pButton pRipple type="button"
            class="p-button p-button-danger"
            style="min-width:150px;"
            (click)="clearTerminalAndRetryPayment()"><span class="p-button-icon p-button-icon-left pi pi-replay" aria-hidden="true"></span><span class="p-button-label">Clear Terminal</span></button>
          </div>
        </ng-template>
      </p-dialog>

      <p-dialog [(visible)]="showPaymentFailedDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
        <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
          <div style="width:60px; height:60px; border-radius:50%; background:#fef2f2; display:flex; align-items:center; justify-content:center;">
            <i class="pi pi-times-circle" style="font-size:2rem; color:#dc2626;"></i>
          </div>
          <div style="font-size:1.2rem; font-weight:700; color:#111827;">Payment Failed</div>
          <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">{{paymentFailedMessage}}</div>
        </div>
        <ng-template #footer>
          <div style="display:flex; justify-content:center; padding-bottom:8px;">
            <button pButton pRipple type="button"
              class="p-button p-button-danger"
              style="min-width:140px;"
              (click)="showPaymentFailedDialog=false; paymentButtonLocked=false;"><span class="p-button-icon p-button-icon-left pi pi-refresh" aria-hidden="true"></span><span class="p-button-label">Try Again</span></button>
            </div>
          </ng-template>
        </p-dialog>

        @if (showTimer) {
          <div>
            @if (ActualTimeRemaining <= 0) {
              <div class="bookingCountdown">
                Time remaining to complete this booking:  {{ 0 | date:'mm:ss' }}
              </div>
            }
            @if (ActualTimeRemaining > 0) {
              <div class="bookingCountdown">
                Time remaining to complete this booking:  {{ ActualTimeRemaining | date:'mm:ss' }}
              </div>
            }
          </div>
        }
        @if (BookingTimeElasped  && !BookingComplete) {
          <div>
            <div class="clearboth"></div>
            <div style="text-align: center;width: 100%;font-size: 17px;font-weight: bold;padding-top: 5vh;padding-bottom: 50vh;padding-left:20px;padding-right:20px">Your booking session has timed out, please click on the button below to restart.
              <div style="text-align: center; width: 100%; padding-top:40px;" class="StartAgainButton">
                <p-button class="p-button" class="Margin0Padding0" label="Click" icon="pi pi-times" iconPos="left" label="Make a new Booking" (click)="returnHome()"></p-button>
              </div>
            </div>
          </div>
        }
        @if (!AccessAllowed && CompletedLoading) {
          <div>
            <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
          </div>
        }
        <p-dialog header="Confirmation Preview" [(visible)]="showPrintConfirmations" [style]="{width: '75vw', height: '75vh'}" [baseZIndex]="10000" [modal]="true">
          <div style="margin-top:5px;padding:0px !important">
            <div class="field mb-4 col-12" id="confToPrint">
              <div style="width:100%" [innerHTML]="confHTML | safe: 'html'">
              </div>
            </div>
          </div>
          <ng-template #footer id="noprint" class="noprint">
            <p-button icon="pi pi-print" label="Print" styleClass="p-button p-button-success" (click)="generatePDF()"></p-button>
            &nbsp;
            <p-button icon="pi pi-times" label="Close" styleClass="p-button p-button-success" (click)="showPrintConfirmations = false;"></p-button>
          </ng-template>
        </p-dialog>
        <p-dialog header="Venue Closing" [(visible)]="showVCWarning" [style]="{width: '50vw', height: '50vh'}" [baseZIndex]="10000" [modal]="true">
          <div class="field mb-4 col-12">
            <div [innerHTML]="VCWarningMessage | safe: 'html'">
            </div>
          </div>

          <ng-template #footer>
            <p-button icon="pi pi-check" label="Continue" styleClass="p-button p-button-success" (click)="VCContinue()"></p-button>
          </ng-template>

        </p-dialog>
        <p-dialog header="Deferral Reason" [(visible)]="showDeferReason" [style]="{width: '50vw', height: '50vh'}" [baseZIndex]="10000" [modal]="true">
          <div class="field mb-4 col-12">
            <div>
              <textarea pInputText type="text" style="width:100%; height: 15vw;" [(ngModel)]="deferNotes"></textarea>
            </div>
          </div>

          <ng-template #footer>
            <p-button icon="pi pi-pencil" label="Save Note" styleClass="p-button p-button-success" (click)="doReferralNote()"></p-button>
          </ng-template>

        </p-dialog>
        <p-dialog header="Please Note (Scroll to the bottom to agree)" [(visible)]="showWarning" [style]="{width: '50vw', height: '70vh'}" [baseZIndex]="10000" [modal]="true">
          <div class="field mb-4 col-12" style="max-height: 55vh; overflow-y: auto; padding-right: 10px;">
            <div [innerHTML]="WarningMessage | safe: 'html'">
            </div>
            <div style="text-align: center; margin-top: 20px; padding-top: 20px; border-top: 1px solid #ddd;">
              <p-button icon="pi pi-check" label="I agree" styleClass="p-button p-button-success" (click)="WarningContinue()"></p-button>
            </div>
          </div>
          <div style="font-weight: 700;font-size: 1.25em;">
            Please Note (Scroll to the bottom to agree)
          </div>
        </p-dialog>
        @if (!BookingComplete && AccessAllowed && !BookingTimeElasped) {
          <div style="padding: 1rem;">
            <h3 style="float:left;">{{makeABookingHeader}}</h3>
            <div style="float:right;margin-bottom:10px;">
              <p-button class="p-button" [style]="{'margin': '0px', 'padding' : '0px'}" label="Click" icon="pi pi-times" iconPos="left" label="Start Again" (click)="returnHome()"></p-button>
            </div>
            <div style="clear:both;"></div>
            <!-- Opened from a booking the AI-Assistant prepared: each step is filled in, and staff check it. -->
            @if (prefill) {
              <div class="mab-prefill-note"><span class="pi pi-comments" style="margin-right:8px;"></span>Filled in by the AI-Assistant: {{prefill.packageName}} on {{prefill.date.substring(8, 10)}}/{{prefill.date.substring(5, 7)}}/{{prefill.date.substring(0, 4)}} at {{prefill.time}}. It goes through the steps itself and stops where you are needed - check the booking on Notes, then press Next to take payment.</div>
            }
            @if (packages) {
              <div>
                <app-accordion expandIcon="pi pi-chevron-right" collapseIcon="pi pi-chevron-down">
                  <app-accordiontab [(selected)]="dateSelected" [disabled]="dateActive" >
                    <ng-template pTemplate="header">
                      <div style="width:100%">
                        <span class="pi pi-calendar" style="margin-right: 10px;" [dateFormat]="dd/mm/yy"></span>{{CalendarHeader}}
                      </div>
                    </ng-template>
                    <div class="surface-card p-4 shadow-2 border-round">
                      <div class="grid formgrid p-fluid">
                        <div class="field mb-4 col-12">
                          <label for="ddlPackage" style="float:left; width:100%" class="font-medium">Date</label>
                          <div style="max-width: 500px;float:left;">
                            <p-datepicker [selectOtherMonths]="true" firstDayOfWeek="1" [(ngModel)]="SelectedDate" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="doneDate()"></p-datepicker>
                          </div>
                          <div style="width:525px; float:left; margin-left:10px;">
                            <button pButton type="button" style="width:120px;" class="p-element p-ripple p-button p-component" (click)="switchToToday()">
                              <span>Today</span>
                            </button>
                            &nbsp;
                            <button pButton type="button" style="width:120px;" class="p-element p-ripple p-button p-component" (click)="switchTomorrow()">
                              <span>Tomorrow</span>
                            </button>
                            &nbsp;
                            <button pButton type="button" style="width:120px;" class="p-element p-ripple p-button p-component" (click)="switchToSaturday()">
                              <span>Saturday</span>
                            </button>
                            &nbsp;
                            <button pButton type="button" style="width:120px;" class="p-element p-ripple p-button p-component" (click)="switchToSunday()">
                              <span>Sunday</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </app-accordiontab>
                  <app-accordiontab [(selected)]="packageSelected" [disabled]="packageActive">
                    <ng-template pTemplate="header">
                      <div style="width:100%">
                        <span class="pi pi-box" style="margin-right: 10px;"></span>{{PackageHeader}}
                      </div>
                    </ng-template>
                    <div class="surface-card p-4 shadow-2 border-round">
                      <div class="grid formgrid p-fluid">
                        Select the Package groups you are interested in below
                        <div style="width:100%">
                          @for (pg of packageGroups; track pg) {
                            <span style="padding: 10px; float: left;">
                              <p-togglebutton [(ngModel)]="checked[pg.packagegroupid]" onLabel="{{pg.packagegroupname}}" offLabel="{{pg.packagegroupname}}" (onChange) = "changedPGSelection(pg)"></p-togglebutton>
                            </span>
                          }
                        </div>
                        <div style="clear: both;"></div>
                        @for (p of packages; track p) {
                          <div class="surface-card p-4 shadow-2 border-round packageCard">
                            <div id="image">
                              <img src="{{p.imageurl}}" style="width:100%">
                            </div>
                            @if (IsDiscountValid(p)) {
                              <div style="width: 100%;background-color: #d30000;color: white;text-align: center;padding: 15px;font-weight: bold;">
                                <span>
                                  <img src="assets/images/littlebird.png" style="width: 50px;padding-right: 10px;">
                                </span>
                                <span>
                                  You are entitled to an early bird discount
                                </span>
                              </div>
                            }
                            <div style="font-weight: bold; padding: 20px;font-size:larger;">{{ p.name }}</div>
                            <div  id="dv{{p.packageId}}collapse" style="padding-left: 20px; padding-right: 20px;height:100px;" [innerHTML]="p.description != null ? (p.description.length < 100 ? p.description : (p.description.substring(0,100)) + '...') : ''">
                            </div>
                            <div id="dv{{p.packageId}}expanded" hidden="true" style="padding-left: 20px; padding-right: 20px;height:100%;" [innerHTML]="p.description">
                            </div>
                            <div style="height: 120px;">
                            </div>
                            <div style="position: absolute; bottom: 0px;width:100%;padding: 20px;text-align: right;">
                              @if (p.description.length > 99) {
                                <button pButton type="button" value="Show More..." id="dv{{p.packageId}}toggleButton" style="width:178px;" class="p-button-secondary p-button-text" (click)="toggleMore('dv'+p.packageId)">
                                  <span>Show More...</span>
                                </button>
                              }
                              <div>
                                <p-button label="Book this Package" icon="pi pi-check" (click)="donePackage(p)">
                                </p-button>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </app-accordiontab>
                  <app-accordiontab [(selected)]="admissionsSelected" [disabled]="admissionsActive">
                    <ng-template pTemplate="header">
                      <div style="width:100%">
                        <span class="pi pi-users" style="margin-right: 10px;"></span> {{AdmissionHeader}}
                      </div>
                    </ng-template>
                    <div class="surface-card p-4 shadow-2 border-round">
                      <!--<div style="color:red; font-weight:bold;">(FOR TESTING)Total Discounts: {{totalDiscount | currency:CurrencySymbol}}</div> -->
                      <div class="grid formgrid p-fluid">
                        <div class="field mb-4 col-12">
                          @if (totalAdmissionInRange) {
                            <div>
                              <b>Total Admissions:</b> {{totalAdmissions}}
                              <br/><br/>
                            </div>
                          }
                          @if (SelectedPackage != null && !totalAdmissionInRange && totalAdmissions < SelectedPackage.min) {
                            <div style="color: red;">
                              <b>Total Admissions:</b> {{totalAdmissions}} - Please select at least {{SelectedPackage.min}} admissions.
                              <br/><br/>
                            </div>
                          }
                          @if (SelectedPackage != null && !totalAdmissionInRange && totalAdmissions > SelectedPackage.max) {
                            <div style="color: red;">
                              <b>Total Admissions:</b> {{totalAdmissions}} - Please select {{SelectedPackage.max}} admissions or less.
                              <br/><br/>
                            </div>
                          }
                          @for (a of (SelectedAdmissions); track a) {
                            <div class="packageSelection clr">
                              @if (a.mustinclude) {
                                <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                                  {{a.bookingwizardtext}} *:
                                </div>
                              }
                              @if (!a.mustinclude) {
                                <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                                  {{a.bookingwizardtext}}:
                                </div>
                              }
                              <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                                <p-inputnumber [(ngModel)]="SelectedAdmissions[a.index].noofpeople" [disabled]="a.fixed" [id]="'ad'+a.name" [showButtons]="true" max="{{a.max}}" min="{{a.min}}" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="sumAdmissions(SelectedAdmissions[a.index])" (onBlur)="sumAdmissions(SelectedAdmissions[a.index])"></p-inputnumber>
                              </div>
                              @if (!a.countstowardsmin) {
                                <div style="margin-top: -14px; margin-bottom: 20px;color:red;">
                                  <span>{{a.message}}</span>
                                </div>
                              }
                            </div>
                          }
                          <div style="clear:both;">
                            <button pButton type="button" style="height: 50px; width: auto; min-width: 258px; white-space: nowrap; margin-top:20px;" class="p-button p-button" (click)="doneAdmissions()">
                              <span>Select these Admissions</span>
                              <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                            </button>
                          </div>
                          <br />
                          * denotes that you must have at least one of these.
                        </div>
                      </div>
                    </div>
                  </app-accordiontab>
                  @if (includesComplexResources || includesOptionalResources) {
                    <app-accordiontab [(selected)]="partyroomsSelected" [disabled]="partyroomsActive">
                      <ng-template pTemplate="header">
                        <div style="width:100%">
                          <span class="pi pi-sitemap" style="margin-right: 10px;"></span> {{SelResourceHeader}}
                        </div>
                      </ng-template>
                      <div class="surface-card p-4 shadow-2 border-round">
                        <div class="grid formgrid p-fluid">
                          <div class="field mb-4 col-12">
                            @for (a of (SelectedResources); track a; let ai = $index) {
                              <div class="packageSelection clr">
                                @if (a.mode == 'COMPLEX' && a.selectionmode != 'SYSTEMANY' && a.selectionmode != 'SYSTEMLIST' && a.selectionmode != '') {
                                  <div  class="PackageSelectLabel" style="margin-bottom: 8px;">
                                    @if (!a.optional) {
                                      <div style="margin-bottom:10px;"><b>Please select one of these {{a.name}}:</b></div>
                                    }
                                    @if (a.optional) {
                                      <div style="margin-bottom:10px;">
                                        <div style="width:55px; float:left;"><p-toggleswitch [(ngModel)]="SelectedSeletableResourceBool[ai]"></p-toggleswitch></div>
                                        @if (!a.isconstructed == true) {
                                          <div style="width:400px;float:left"><b>Would you like a {{a.name}}?</b></div>
                                        }
                                        @if (a.isconstructed == true) {
                                          <div style="width:400px;float:left"><b>Would you like to choose a {{a.name}}?</b></div>
                                        }
                                        <div style="clear:both;"></div>
                                      </div>
                                    }
                                    @if (a.optional && SelectedSeletableResourceBool[ai] && a.isconstructed == true) {
                                      <div >
                                        @for (r of (a.resources); track r) {
                                          <div class="packageSelection clr">
                                            @if (!r.disabled) {
                                              <label style="display:flex; align-items:center; gap:8px; margin:5px 0 5px 10px; cursor:pointer;"><p-radiobutton name="{{a.groupname}}" value="{{r.id}}" [(ngModel)]="SelectedSeletableResource[ai]"></p-radiobutton><span>{{r.name}}</span></label>
                                            }
                                          </div>
                                        }
                                        <div style="clear:both;"></div>
                                      </div>
                                    }
                                    @if (!a.optional) {
                                      <div >
                                        @for (r of (a.resources); track r) {
                                          <div class="packageSelection clr">
                                            @if (!r.disabled) {
                                              <label style="display:flex; align-items:center; gap:8px; margin:5px 0 5px 10px; cursor:pointer;"><p-radiobutton name="{{a.groupname}}" value="{{r.id}}" [(ngModel)]="SelectedSeletableResource[ai]"></p-radiobutton><span>{{r.name}}</span></label>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                    @if (!validselection[ai] && validselection[ai] != null) {
                                      <div class="text-danger" Style="margin-left:10px;">
                                        <div style="clear:both;"></div>
                                        <span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select from the list above.
                                      </div>
                                    }
                                    @if (a.quantityselector == 'CUSTOM' && a.optional) {
                                      <div Style="margin-left:10px;">
                                        <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                                          How many of the above resources would you like?
                                        </div>
                                        <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                                          <p-inputnumber [(ngModel)]="a.quantity" [showButtons]="true" max="100" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                                        </div>
                                      </div>
                                    }
                                    <hr>
                                    </div>
                                  }
                                  @if (a.mode == 'COMPLEX'
                                    && a.optional && a.selectionmode == '') {
                                    <div  class="PackageSelectLabel" style="margin-bottom: 8px;">
                                      @if (!a.optional) {
                                        <div style="margin-bottom:10px;"><b>Please select one of these {{a.name}}:</b></div>
                                      }
                                      @if (a.optional) {
                                        <div style="margin-bottom:10px;">
                                          <div style="width:55px; float:left;"><p-toggleswitch [(ngModel)]="SelectedSeletableResourceBool[ai]"></p-toggleswitch></div>
                                          @if (!a.isconstructed == true) {
                                            <div style="width:400px;float:left"><b>Would you like a {{a.name}}?</b></div>
                                          }
                                          @if (a.isconstructed == true) {
                                            <div style="width:400px;float:left"><b>Would you like to choose a {{a.name}}?</b></div>
                                          }
                                          <div style="clear:both;"></div>
                                        </div>
                                      }
                                      @if (SelectedSeletableResourceBool[ai] && a.quantityselector == 'CUSTOM') {
                                        <div Style="margin-left:10px;">
                                          <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                                            How many of the above resource would you like?
                                          </div>
                                          <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                                            <p-inputnumber [(ngModel)]="a.quantity" [showButtons]="true" max="100" min="1" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                                          </div>
                                        </div>
                                      }
                                      <hr>
                                      </div>
                                    }
                                  </div>
                                }
                                <div style="clear:both;">
                                  <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;" class="p-button p-button" (click)="donePartyRooms()">
                                    <span>Add this Selection</span>
                                    <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </app-accordiontab>
                      }
                      <app-accordiontab [(selected)]="timeSelected" [disabled]="timeActive">
                        <ng-template pTemplate="header">
                          <div style="width:100%">
                            <span class="pi pi-clock" style="margin-right: 10px;"></span> {{TimeHeader}}
                          </div>
                        </ng-template>
                        <div class="surface-card p-4 shadow-2 border-round">
                          @if (!disgnosticsMode) {
                            <div>
                              @for (st of (startTimesFiltered); track st) {
                                <div class="times">
                                  <!--<p-button style="margin:0px;" class="p-button" label="Click" icon="pi pi-clock" iconPos="left" label="Move booking to {{ st.time | date:'HH:mm' : 'UTC' }}" (click)="bookSlot(st)"></p-button>-->
                                  <button style="padding: 25px 43px 25px 43px;font-weight:bold;" class="p-button" (click)="bookSlot(st)">
                                    <span class="pi pi-clock" style="margin-right:8px;"></span>
                                    {{ st.time | date:'HH:mm' : 'UTC'}}
                                  </button>
                                </div>
                              }
                            </div>
                          }
                          @if (disgnosticsMode) {
                            <div>
                              @for (st of (startTimes); track st) {
                                <div>
                                  <!--<input type=button class='bookButtonND' value="{{ st.time | date:'HH:mm' }}" id='btnbook' (click)="bookSlot(st.time)">-->
                                  <div style="width:100%; margin-bottom: 10px;">
                                    @if (st.primaryResource == true && st.timeAvailable == true) {
                                      <div class="times">
                                        <div style="float:left;">
                                          <button style="padding: 25px 43px 25px 43px;;font-weight:bold;" class="p-button" (click)="bookSlot(st)">
                                            <span class="pi pi-clock" style="margin-right:8px;"></span>
                                            {{ st.time | date:'HH:mm' : 'UTC'}}
                                          </button>
                                        </div>
                                      </div>
                                    }
                                    @if (st.primaryResource == true && st.timeAvailable == false) {
                                      <div style="width:100%;">
                                        <div style="float:left;">
                                          <!--<p-button style="margin:0px;" class="p-button" label="Click" disabled="true" icon="pi pi-clock" iconPos="left" label="{{ st.time | date:'HH:mm' : 'UTC' }}"></p-button>-->
                                          <button style="padding: 25px 43px 25px 43px;;font-weight:bold;color:#bbbbbb" class="p-button" [disabled]="true">
                                            <span class="pi pi-clock" style="margin-right:8px;"></span>
                                            {{ st.time | date:'HH:mm' : 'UTC'}}
                                          </button>
                                        </div>
                                      </div>
                                    }
                                    @if (st.primaryResource == true) {
                                      <div  style="font-size: 17px;margin-top: 25px;width: 200px;float: left;margin-left: 20px;">Quantity Remaining: {{ st.quantityRemaining }}</div>
                                    }
                                    @if (st.primaryResource == true && st.reason != "") {
                                      <div style="font-size: 17px;margin-top: 15px;width: 400px;float: left;margin-left: 20px;background-color: pink;padding:10px;border-radius:40px;text-align:center;">Reason: {{ st.reason }}</div>
                                    }
                                    @if (st.primaryResource == true && st.reason == "") {
                                      <div style="font-size: 17px;margin-top: 15px;width: 400px;float: left;margin-left: 20px;background-color: #91ff91;padding:10px;border-radius:40px;text-align:center;">No issues found</div>
                                    }
                                  </div>
                                  <div style="clear:both;"></div>
                                </div>
                              }
                            </div>
                          }
                          <div style="clear: both; height:75px;"></div>
                          @if (startTimesFiltered === null || startTimesFiltered === undefined || startTimesFiltered.length == 0) {
                            <div style="margin-top: -50px; margin-bottom: 68px;">{{NoAvailabilityMessage}}</div>
                          }
                        </div>
                      </app-accordiontab>
                      @if (showUpgradesScreen == true) {
                        <app-accordiontab  [(selected)]="upgradeSelected" [disabled]="upgradeActive">
                          <ng-template pTemplate="header">
                            <div style="width:100%">
                              <span class="pi pi-arrow-up" style="margin-right: 10px;"></span> {{UpgradeHeader}}
                            </div>
                          </ng-template>
                          <div class="surface-card p-4 shadow-2 border-round">
                            <div class="grid formgrid p-fluid">
                              <div class="field mb-4 col-12">
                                @for (pu of availablePackageUpgrades; track pu) {
                                  <div class="surface-card p-4 shadow-2 border-round packageCard">
                                    <div id="image">
                                      <img src="{{pu.upgrade.imageurl}}" style="width:100%">
                                    </div>
                                    <div style="font-weight: bold; padding: 20px;font-size:larger;">{{ pu.name }}</div>
                                    <div  id="dv{{pu.packageupgradeid}}collapse" style="padding-left: 20px; padding-right: 20px;height:100px;" [innerHTML]="pu.upgrade.description != null ? (pu.upgrade.description.length < 100 ? pu.upgrade.description : (pu.upgrade.description.substring(0,100)) + '...') : ''">
                                    </div>
                                    <div id="dv{{pu.packageId}}expanded" hidden="true" style="padding-left: 20px; padding-right: 20px;height:100%;" [innerHTML]="pu.upgrade.description">
                                    </div>
                                    <div style="height: 120px;">
                                    </div>
                                    <div style="position: absolute; bottom: 0px;width:100%;padding: 20px;text-align: right;">
                                      @if (pu.upgrade.description.length > 99) {
                                        <button pButton type="button" value="Show More..." id="dv{{pu.packageupgradeid}}toggleButton" style="width:178px;" class="p-button-secondary p-button-text" (click)="toggleMore('dv'+pu.packageupgradeid)">
                                          <span>Show More...</span>
                                        </button>
                                      }
                                      <div>
                                        <p-button label="Add this Upgrade" icon="pi pi-check" (click)="doneUpgrade(pu)">
                                        </p-button>
                                      </div>
                                    </div>
                                  </div>
                                }
                                <div style="clear:both;"></div>
                                <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;margin-left:15px;" class="p-button p-button" (click)="skipUpgrade(pu)">
                                  <span class="pi pi-thumbs-down" style="margin-right:8px;"></span>
                                  <span>Skip Upgrades</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </app-accordiontab>
                      }
                      <!--Admissions Based Upgrades-->
                      @if (showOptionalUpgradesScreen == true) {
                        <app-accordiontab [(selected)]="optionalUpgradeSelected" [disabled]="optionalUpgradeActive">
                          <ng-template pTemplate="header">
                            <div style="width:100%">
                              <span class="pi pi-arrow-up" style="margin-right: 10px;"></span> {{OptionalUpgradeHeader}}
                            </div>
                          </ng-template>
                          <div class="surface-card p-4 shadow-2 border-round">
                            <div class="grid formgrid p-fluid">
                              <div class="field mb-4 col-12">
                                @for (pu of availablePackageOptionalUpgrades; track pu) {
                                  <div class="surface-card p-4 shadow-2 border-round packageCard">
                                    <div id="image">
                                      <img src="{{pu.upgrade.imageurl}}" style="width:100%">
                                    </div>
                                    <div style="font-weight: bold; padding: 20px;font-size:larger;width:100%;float:left;">{{ pu.name }}</div>
                                    <div>
                                      <div id="dv{{pu.packageupgradeid}}collapse" style="padding-left: 20px; padding-right: 20px;height:100%;;width:100%;float:left;" [innerHTML]="pu.upgrade.description != null ? (pu.upgrade.description.length < 100 ? pu.upgrade.description : (pu.upgrade.description.substring(0,100)) + '...') : ''">
                                      </div>
                                      <div id="dv{{pu.packageupgradeid}}expanded" hidden="true" style="padding-left: 20px; padding-right: 20px;height:100%;;width:100%;float:left;" [innerHTML]="pu.upgrade.description">
                                      </div>
                                    </div>
                                    <div style="clear:both"></div>
                                    <div style="float:left;width:100%;padding: 20px;text-align: right;margin-bottom:20px;">
                                      @if (pu.upgrade.description.length > 99) {
                                        <button pButton type="button" value="Show More..." id="dv{{pu.packageupgradeid}}toggleButton" style="width:178px;" class="p-button-secondary p-button-text" (click)="toggleMore('dv'+pu.packageupgradeid)">
                                          <span>Show More...</span>
                                        </button>
                                      }
                                      <div style="text-align: left;float:left;width:100%;">
                                        <label for="qty{{pu.packageupgradeid}}" class="font-medium" style="margin-bottom:10px;">Quantity required:</label>
                                        <p-select [style]="{'width': '100%' }" optionLabel="name" optionValue="value" [options]="pu | getQuantityOptions:getOptionalUpgradeQuantities" [(ngModel)]="pu.quantity" placeholder="Select Quantity" id="qty{{pu.packageupgradeid}}"></p-select>
                                      </div>
                                    </div>
                                  </div>
                                }
                                <div style="clear:both;"></div>
                                <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;margin-left:15px;" class="p-button p-button" (click)="doneOptionalUpgrade()">
                                  <span>Select These Add-Ons</span>
                                  <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                </button>
                                <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;margin-left:15px;" class="p-button p-button" (click)="skipOptionalUpgrade(pu)">
                                  <span class="pi pi-thumbs-down" style="margin-right:8px;"></span>
                                  <span>Skip Add-Ons</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </app-accordiontab>
                      }
                      <!----------------------------->
                      @if (SelectedPackage && SelectedPackage.questionnaire) {
                        <app-accordiontab [(selected)]="bookingQuestionsSelected" [disabled]="bookingQuestionsActive">
                          <ng-template pTemplate="header">
                            <div style="width:100%">
                              <span class="pi pi-question-circle" style="margin-right: 10px;"></span> Booking Questions
                            </div>
                          </ng-template>
                          <div class="surface-card p-4 shadow-2 border-round">
                            <div class="grid formgrid p-fluid">
                              @for (bq of SelectedPackage.questionnaire.bookingquestions; track bq) {
                                <div class="field mb-4 col-12">
                                  @if (bq.questiontype=='FREETEXT' && bq.answers != null) {
                                    <div>
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <input id="bq{{bq.id}}" type="text" [(ngModel)]="bq.answers.freetextanswer" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerfreetext[bq.listorder]}">
                                      @if (!mustanswerfreetext[bq.listorder]) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question.</div>
                                      }
                                    </div>
                                  }
                                  @if (bq.questiontype=='BIRTHDAY' && bq.answers != null) {
                                    <div>
                                      <div style="width:100%; float:left;"><label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label></div>
                                      @for (ibq of bq.answers.birthdayanswers; track ibq) {
                                        <div style="width: 100%;">
                                          <div style="width:100%">
                                            <div>
                                              <div style="min-width: 300px; width:31%; float:left; margin-right:1%;margin-bottom:10px;margin-top: 5px;">
                                                Name<br>
                                                <input id="bqname{{bq.id}}_{{ibq.id}}" type="text" [(ngModel)]="ibq.name" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.name == '' || ibq.name == null)}">
                                              </div>
                                              @if (bq.showage) {
                                                <div style="min-width: 300px; width:31%; float:left; margin-right:1%;margin-bottom:10px;margin-top: 5px;">
                                                  Age<br>
                                                  <!-- <p-inputnumber [showButtons]="true" [(ngModel)]="ibq.age"  buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber> -->
                                                  <p-select [showClear]="true" [options]="ageOptionsFor(bq)" [(ngModel)]="ibq.age" placeholder="Select age" optionLabel="name" optionValue="value" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.age == '' || ibq.age == null)}"></p-select>
                                                </div>
                                              }
                                              @if (bq.showdob) {
                                                <div style="min-width: 300px; width:31%; float:left;margin-bottom:10px;margin-top: 5px;">
                                                  Date of Birth<br>
                                                  <p-select [style]="{'float': 'left', 'width': '96px' }" optionLabel="name" optionValue="value" [options]="caldays" [(ngModel)]="ibq.dobday" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-select>
                                                  <span style="float:left;margin-top: 12px;">&nbsp;/&nbsp;</span>
                                                  <p-select [style]="{'float': 'left', 'width': '96px' }"  optionLabel="name" optionValue="value" [options]="calmonths" [(ngModel)]="ibq.dobmonth" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-select>
                                                  <span style="float:left;margin-top: 12px;">&nbsp;/&nbsp;</span>
                                                  <p-select [style]="{'float': 'left', 'width': '115px' }"  optionLabel="name" optionValue="value" [options]="calyears" [(ngModel)]="ibq.dobyear" placeholder="----" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-select>
                                                </div>
                                              }
                                              @if (bq.answers.birthdayanswers.length > 1 && !bq.linkedtoparticipants) {
                                                <div style="float:left; margin-top: 24px; margin-left: 10px;">
                                                  <button pButton type="button" style="height: 50px; width: 58px;" class="p-button-danger p-button" (click)="deleteBirthdayRow(bq, ibq.id)">
                                                    <span class="pi pi-trash"></span>
                                                  </button>
                                                </div>
                                              }
                                            </div>
                                            <div style="clear:both;"></div>
                                            @if (!DOBIsValid) {
                                              <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Please enter a valid date.</div>
                                            }
                                            <div style="width:100%">
                                              @if (bq.showgender) {
                                                <div style="min-width: 300px; width:48%; float:left; margin-right:1%;margin-bottom:10px;margin-top: 5px;">
                                                  Gender<br>
                                                  <p-selectbutton id="bqgender{{bq.id}}_{{ibq.id}}" [style]="{'min-width' : '300px'}" [options]="stateGenderOptions" [(ngModel)]="ibq.gender" ></p-selectbutton>
                                                </div>
                                              }
                                              @if (bq.showinterests) {
                                                <div style="min-width: 300px; width:48%; float:left; margin-right:1%;margin-bottom:10px;margin-top: 5px;">
                                                  Interests<br>
                                                  <input id="bqint{{bq.id}}_{{ibq.id}}" type="text" [(ngModel)]="ibq.interests" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.interests == '' || ibq.interests == null)}">
                                                </div>
                                              }
                                            </div>
                                          </div>
                                          <div style="clear:both;"></div>
                                        </div>
                                      }
                                      <div style="clear:both;"></div>
                                      @if (!bq.linkedtoparticipants) {
                                        <div style="width:100%">
                                          <button pButton type="button" style="height: 50px; width: 225px;margin-top:20px;" class="p-button p-button" (click)="addBirthdayRow(bq)">
                                            <span>Add another</span>
                                            <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                          </button>
                                        </div>
                                      }
                                      @if (!mustanswerbirthdays[bq.listorder]) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide all details.</div>
                                      }
                                    </div>
                                  }
                                  @if (bq.questiontype=='ALLERGY' && bq.answers != null) {
                                    <div>
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <p-selectbutton id="allergy" [style]="{'width': '100%', 'max-width' : '230px'}" [options]="stateOptionAllergy" [(ngModel)]="bq.answers.allergyanswer.allergypresent" [ngClass]="{'ng-invalid ng-dirty': bq.answers.allergyanswer.allergypresent == null}"></p-selectbutton>
                                      <!--<p-select [options]="allergyOptions" [(ngModel)]="bq.answers.allergyanswer.allergypresent" placeholder="Choose an answer" [showClear]="true" optionLabel="name" optionValue="value"></p-select>-->
                                      @if (bq.answers.allergyanswer.allergypresent == null) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide an answer to whether an allergy is present or not..</div>
                                      }
                                      @if (bq.answers.allergyanswer.allergypresent==true) {
                                        <div>
                                          <label for="bq{{bq.id}}" style="margin-top:20px;" class="font-medium">Please specify any allergy details below</label>
                                          <input id="bq{{bq.id}}" type="text" [(ngModel)]="bq.answers.allergyanswer.allergytext" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerallergies[bq.listorder]}">
                                        </div>
                                      }
                                      @if (!mustanswerallergies[bq.listorder] && bq.answers.allergyanswer.allergypresent==true) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide allergy details.</div>
                                      }
                                    </div>
                                  }
                                  @if (bq.questiontype=='REGISTER' && bq.answers != null) {
                                    <div>
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <!-- A register is the list of people on the booking. The name is always asked for; the rest
                                      of the fields are whichever ones the question was set up to include, and the last one
                                      carries the venue's own wording. -->
                                      @for (ibq of bq.answers.birthdayanswers; track ibq; let pi = $index) {
                                        <div class="bqperson">
                                          <div class="bqperson-head">
                                            <span class="bqperson-title">{{ibq.name != null && ibq.name != '' ? ibq.name : 'Person ' + (pi + 1)}}</span>
                                            @if (bq.answers.birthdayanswers.length > 1 && !bq.linkedtoparticipants) {
                                              <button pButton type="button" class="p-button-danger p-button-text p-button-sm bqperson-delete" (click)="deleteBirthdayRow(bq, ibq.id)">
                                                <span class="pi pi-trash" style="margin-right:6px;"></span>
                                                <span>Delete</span>
                                              </button>
                                            }
                                          </div>
                                          <div class="bqfields">
                                            <div class="bqfield bqfield--name">
                                              <label class="bqlabel" for="bqrname{{bq.id}}_{{ibq.id}}">Name</label>
                                              <input id="bqrname{{bq.id}}_{{ibq.id}}" type="text" placeholder="Name" [(ngModel)]="ibq.name" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.name == '' || ibq.name == null)}">
                                            </div>
                                            @if (bq.showage) {
                                              <div class="bqfield bqfield--age">
                                                <label class="bqlabel">Age</label>
                                                <p-select [options]="ageOptionsFor(bq)" [(ngModel)]="ibq.age" placeholder="Select age" optionLabel="name" optionValue="value" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.age == '' || ibq.age == null)}"></p-select>
                                              </div>
                                            }
                                            @if (bq.showdob) {
                                              <div class="bqfield bqfield--dob">
                                                <label class="bqlabel">Date of Birth</label>
                                                <div class="bqdob">
                                                  <p-select class="bqdob-day" optionLabel="name" optionValue="value" [options]="caldays" [(ngModel)]="ibq.dobday" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-select>
                                                  <span class="bqdob-sep">/</span>
                                                  <p-select class="bqdob-month" optionLabel="name" optionValue="value" [options]="calmonths" [(ngModel)]="ibq.dobmonth" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-select>
                                                  <span class="bqdob-sep">/</span>
                                                  <p-select class="bqdob-year" optionLabel="name" optionValue="value" [options]="calyears" [(ngModel)]="ibq.dobyear" placeholder="----" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-select>
                                                </div>
                                              </div>
                                            }
                                            @if (bq.showinterests) {
                                              <div class="bqfield bqfield--interests">
                                                <label class="bqlabel" for="bqrextra{{bq.id}}_{{ibq.id}}">{{bq.warningtext}}</label>
                                                <input id="bqrextra{{bq.id}}_{{ibq.id}}" type="text" [(ngModel)]="ibq.interests" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.interests == '' || ibq.interests == null)}">
                                              </div>
                                            }
                                          </div>
                                        </div>
                                      }
                                      @if (!bq.linkedtoparticipants) {
                                        <div>
                                          <button pButton type="button" class="p-button bqaddanother" (click)="addBirthdayRow(bq)">
                                            <span>Add another</span>
                                            <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                          </button>
                                        </div>
                                      }
                                      @if (!mustanswerbirthdays[bq.listorder]) {
                                        <div class="text-danger" style="margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide all details.</div>
                                      }
                                    </div>
                                  }
                                  @if (bq.questiontype=='AGE' && bq.answers != null) {
                                    <div>
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <p-inputnumber [showButtons]="true" buttonLayout="horizontal" [(ngModel)]="bq.answers.numberanswer" min="{{bq.minage}}" max="{{bq.maxage}}" spinnerMode="horizontal" [ngClass]="{'ng-invalid ng-dirty': !mustanswerage[bq.listorder]}"></p-inputnumber>
                                      @if (!mustanswerage[bq.listorder]) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide age details.</div>
                                      }
                                    </div>
                                  }
                                  @if (bq.questiontype=='MULTICHOICESINGLE' && bq.answers != null) {
                                    <div>
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <div>
                                        <p-select [options]="bq.listitems" placeholder="Please select an option" optionLabel="listitemtext" [(ngModel)]="bq.answers.multichoicesingleanswer" [ngClass]="{'ng-invalid ng-dirty': !mustanswermultichoicesingleanswer[bq.listorder]}"></p-select>
                                      </div>
                                      @if (!mustanswermultichoicesingleanswer[bq.listorder]) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and choose an item.</div>
                                      }
                                    </div>
                                  }
                                  @if (bq.questiontype=='MULTICHOICEMULTIPLE' && bq.answers != null) {
                                    <div>
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <div>
                                        <p-multiselect [options]="bq.listitems" placeholder="Please select one or more options" optionLabel="listitemtext" [(ngModel)]="bq.answers.multichoicemultianswer" [ngClass]="{'ng-invalid ng-dirty': !mustanswermultichoicemultianswer[bq.listorder]}"></p-multiselect>
                                      </div>
                                      @if (!mustanswermultichoicemultianswer[bq.listorder]) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and choose one or more items.</div>
                                      }
                                    </div>
                                  }
                                  @if (bq.questiontype=='DATE' && bq.answers != null) {
                                    <div>
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <p-datepicker [selectOtherMonths]="true" firstDayOfWeek="1" [(ngModel)]="bq.answers.dateanswer" dateFormat="dd/mm/yy" [showIcon]="true" [ngClass]="{'ng-invalid ng-dirty': !mustanswerdate[bq.listorder]}"></p-datepicker>
                                      @if (!mustanswerdate[bq.listorder]) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and supply a date.</div>
                                      }
                                    </div>
                                  }
                                  @if (bq.questiontype=='NUMBER' && bq.answers != null) {
                                    <div>
                                      <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                      <p-inputnumber [showButtons]="true" buttonLayout="horizontal" [(ngModel)]="bq.answers.numberanswer" spinnerMode="horizontal" [ngClass]="{'ng-invalid ng-dirty': !mustanswernumber[bq.listorder]}"></p-inputnumber>
                                      @if (!mustanswernumber[bq.listorder]) {
                                        <div class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and supply a number.</div>
                                      }
                                    </div>
                                  }
                                  <hr style="margin-bottom:0px;margin-top:20px">
                                </div>
                              }
                            </div>
                            <div style="clear:both;">
                              <button pButton type="button" style="height: 50px; width: 155px;margin-top:20px;" class="p-button p-button" (click)="doneBookingQuestions()">
                                <span>Next</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                              </button> &nbsp;
                            </div>
                          </div>
                        </app-accordiontab>
                      }
                      @if (PackageHasExtras) {
                        <app-accordiontab [(selected)]="extraSelected" [disabled]="extraActive">
                          <ng-template pTemplate="header">
                            <div style="width:100%">
                              <span class="pi pi-star" style="margin-right: 10px;"></span> {{ExtrasHeader}}
                            </div>
                          </ng-template>
                          <div class="col-12">
                            <label class="font-medium">Please select any extras, you would like to add to your booking</label>
                            <!-- One card per extra. The picture column only appears when at least one extra on offer
                            has a picture, so a package with none keeps a plain list, and when some do the rows
                            without one still line up behind a plain white square, as in the public booking wizard. -->
                            <div class="xtra-list">
                              @for (product of packageExtras; track product; let i = $index) {
                                <div class="xtra-card" [class.xtra-card--chosen]="product.qty > 0">
                                  <div class="xtra-row">
                                    @if (extrasHaveImages) {
                                      <div class="xtra-thumb">
                                        @if (product.imageurl) {
                                          <img [src]="product.imageurl" alt="" loading="lazy" (error)="$any($event.target).hidden = true">
                                        }
                                      </div>
                                    }
                                    <div class="xtra-info">
                                      <div class="xtra-name">{{product.name}}</div>
                                      @if (showExtraDescription(product)) {
                                        <div class="xtra-desc">{{product.description}}</div>
                                      }
                                      @if (!isVariableValueExtra(product)) {
                                        <div class="xtra-price">{{product.price | currency:CurrencySymbol}} each</div>
                                      }
                                      <!-- Variable value extra: no set price, so the value is typed in here and saved as its
                                      price. Nothing to type a value into until one has been added, so the box
                                      only appears once a quantity is set. -->
                                      @if (isVariableValueExtra(product) && product.qty > 0) {
                                        <div class="xtra-price">
                                          <label for="xtravalue{{i}}" style="display:block; margin-bottom:4px;">Value (each)</label>
                                          <p-inputnumber inputId="xtravalue{{i}}" [(ngModel)]="product.price" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="99999" placeholder="Enter value" [ngClass]="{'ng-invalid ng-dirty': !allVariableValuesValid && variableValueMissing(product)}" (onInput)="product.price = $event.value; sumExtras()" (onBlur)="sumExtras()"></p-inputnumber>
                                        </div>
                                      }
                                    </div>
                                    <div class="xtra-qty">
                                      <p-inputnumber [(ngModel)]="product.qty" [showButtons]="true" max="{{product.max}}" min="{{product.min}}" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="sumExtras()" (onBlur)="sumExtras()"></p-inputnumber>
                                      <div class="xtra-line" [class.xtra-line--zero]="!(product.qty > 0)">{{(product.qty * product.price) | currency:CurrencySymbol}}</div>
                                    </div>
                                  </div>
                                  @if ((product.question!='' && product.question != null) && product.qty > 0) {
                                    <div class="xtra-question">
                                      <label for="xtraanswer{{i}}">{{product.question}}</label>
                                      <input id="xtraanswer{{i}}" type="text" [(ngModel)]="product.answer" pInputText [ngClass]="{'ng-invalid ng-dirty': !allQuestionsValid && (product.answer == null || product.answer == '')}">
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                            @if (!allQuestionsValid) {
                              <div class="text-danger" Style="margin-left:10px; margin-top: 15px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer all questions.</div>
                            }
                            @if (!allVariableValuesValid) {
                              <div class="text-danger" Style="margin-left:10px; margin-top: 15px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a value for each variable value extra you have added.</div>
                            }
                            <div class="xtra-total"><span>Total</span><span>{{TotalExtras | currency:CurrencySymbol}}</span></div>
                            <div style="clear:both;">
                              <button pButton type="button" style="height: 50px; width: 258px;margin-top:20px;" class="p-button p-button" (click)="doneExtras()">
                                <span>Next</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                              </button>
                            </div>
                          </div>
                        </app-accordiontab>
                      }
                      <app-accordiontab  [(selected)]="customerSelected" [disabled]="customerActive">
                        <ng-template pTemplate="header">
                          <div style="width:100%">
                            <span class="pi pi-user" style="margin-right: 10px;"></span> {{CustomerHeader}}
                          </div>
                        </ng-template>
                        <div style="margin-bottom: 40px;">
                          @if (qbook!='true') {
                            <div>
                              <span style="width:282px;float:left; margin-bottom:20px;">
                                <div>
                                  <input id="MembershipNumber" style="width:272px;" [(ngModel)]="MembershipID" placeholder="Enter Membership Number" pInputText>
                                </div>
                              </span>
                              <button pButton type="button" style="float:left;height: 50px; margin-left:10px;width:228px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="addMembership()">
                                <span class="pi pi-user" style="margin-right:8px;"></span>
                                <span i18>Add Membership</span>
                              </button>
                            </div>
                          }
                          <div style="clear:both;"></div>
                          @if (qbook!='true') {
                            <span class="p-input-icon-left ml-auto" style="margin-right:20px; float:left;">
                              <i class="pi pi-search"></i>
                              <input pInputText type="text" [(ngModel)]="searchCriteria" buttonLayout="horizontal" placeholder="Lastname/Mobile/Email" style="width: 272px; height: 50px;padding-left:33px;" />
                            </span>
                          }
                          @if (qbook!='true') {
                            <button pButton type="button" style="float:left;height: 50px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="searchCustomer()">
                              <span class="pi pi-search" style="margin-right:8px;"></span>
                              <span i18>Search</span>
                            </button>
                          }
                          <!-- <p style="float: left;width: 376px;font-size: 15px;color: #ccc;margin-top: 10px;margin-left: 10px;">(Lastname/Mobile Number/Email)</p>
                          -->
                          @if (qbook!='true') {
                            <button pButton type="button" style="float:left;height: 50px; margin-left:10px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="doWalkin()">
                              <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                              <span i18>Walk in</span>
                            </button>
                          }
                          <div style="clear:both;"></div>
                          @if (customersResult) {
                            <div style="margin-top:20px;" class="surface-card p-4 shadow-2 border-round">
                              <p-table [value]="customersResult.data">
                                <ng-template #header>
                                  <tr style="color:Black;background-color:white;font-weight:bold;">
                                    <th  width="1%">&nbsp;</th>
                                    <th scope="col">Name</th>
                                    <!-- <th scope="col">Address</th> -->
                                    <th scope="col">Mobile</th>
                                    <th scope="col">Email Address</th>
                                    <th width="5%">&nbsp;</th>
                                    <th width="5%">&nbsp;</th>
                                  </tr>
                                </ng-template>
                                <ng-template #body let-data>
                                  <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" style="background-color: rgb(255, 255, 255); cursor: pointer;">
                                    <td>
                                      <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="addselectedCustomer(data)">
                                        <span class="pi pi-check" style="margin-right:8px;"></span>
                                      Select</button>
                                    </td>
                                    @if (data.hasmembership) {
                                      <td>
                                        <button pButton pRipple type="button" class="p-button p-element p-button-secondary" style="width: 33px;height: 40px;background-color: gold;color: black;" (click)="showMemberships(data)">
                                          <span class="pi pi-users" style="margin-left:-9px;"></span>
                                        </button>
                                      </td>
                                    }
                                    @if (!data.hasmembership) {
                                      <td></td>
                                    }
                                    <td>{{data.fullName}}</td>
                                    <td>{{data.mobile}}</td>
                                    <td>{{data.email}}</td>
                                    <td>
                                      <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="applyCustomer(data)">
                                        <span class="pi pi-pencil" style="margin-right:8px;"></span>
                                      Edit</button>
                                    </td>
                                  </tr>
                                  <div style="clear:both;"></div>
                                  <tr id="div-{{data.id}}" style="display:none; width:100%;">
                                    <td colspan="8" style="padding:0px;">
                                      <p-table [value]="data.memberships">
                                        <ng-template #body let-member>
                                          <tr>
                                            <td style="width:100px">&nbsp;</td>
                                            <td>{{member.salesid}}</td>
                                            <td>{{member.startdate | date}}</td>
                                            <td>{{member.enddate | date}}</td>
                                            <td style="text-align: right;">
                                              <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="addselectedMember(member)">
                                                <span class="pi pi-check" style="margin-right:8px;"></span>
                                              Select</button>
                                            </td>
                                          </tr>
                                        </ng-template>
                                      </p-table>
                                    </td>
                                  </tr>
                                </ng-template>
                              </p-table>
                              @if (customersResult) {
                                <button style="margin-top:15px;" pButton pRipple type="button" class="p-button p-element p-button-success" (click)="addCustomer(data)">
                                  <span class="pi pi-pencil" style="margin-right:8px;"></span>
                                Add Customer</button>
                              }
                            </div>
                          }
                        </div>
                        @if (ShowCustomerDetails) {
                          <div class="surface-card p-4 shadow-2 border-round">
                            <div class="grid formgrid p-fluid">
                              @if (IsToday() && qbook!='true') {
                                <div class="field mb-4 col-12">
                                  <p-selectbutton id="exclusive" [style]="{'width': '100%', 'max-width' : '600px'}" [options]="stateOptions" [(ngModel)]="ProvideMinimalPersonalData" ></p-selectbutton>
                                </div>
                              }
                              @if (!IsToday() && qbook!='true') {
                                <div class="field mb-4 col-12">
                                  <p-selectbutton id="exclusive" [style]="{'width': '100%', 'max-width' : '600px'}" [options]="stateOptionsMin" [(ngModel)]="ProvideMinimalPersonalData" ></p-selectbutton>
                                </div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED') {
                                <div class="field mb-4 col-12" >
                                  <label for="firstName" class="font-medium">First Name</label>
                                  <input id="firstName" type="text" [(ngModel)]="firstName" pInputText autocomplete="given-name">
                                </div>
                              }
                              @if (!firstNameValid) {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a first name.</div>
                              }
                              <div class="field mb-4 col-12">
                                <label for="lastname" class="font-medium">Last Name</label>
                                <input id="lastname" type="text" [(ngModel)]="lastName" pInputText autocomplete="family-name">
                              </div>
                              @if (!lastNameValid) {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a last name.</div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL') {
                                <div class="field mb-4 col-12">
                                  <label for="address1" class="font-medium">Address 1</label>
                                  <input id="address1" type="text" [(ngModel)]="address1" pInputText autocomplete="address-line1">
                                </div>
                              }
                              @if (!Address1Valid && ProvideMinimalPersonalData == 'FULL') {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an address.</div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL') {
                                <div class="field mb-4 col-12">
                                  <label for="address2" class="font-medium">Address 2</label>
                                  <input id="address2" type="text" [(ngModel)]="address2" pInputText autocomplete="address-line2">
                                </div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL') {
                                <div class="field mb-4 col-12">
                                  <label for="town" class="font-medium">Town / City</label>
                                  <input id="town" type="text" [(ngModel)]="town" pInputText autocomplete="address-line3">
                                </div>
                              }
                              @if (!TownValid && ProvideMinimalPersonalData == 'FULL') {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a town/city.</div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL') {
                                <div class="field mb-4 col-12">
                                  <label for="postcode" class="font-medium">Post Code</label>
                                  <input id="postcode" type="text" [(ngModel)]="postCode" pInputText autocomplete="postal-code">
                                </div>
                              }
                              @if (!PostCodeValid && ProvideMinimalPersonalData == 'FULL') {
                                <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a postcode.</div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED') {
                                <div style="width:100%">
                                  <div class="field mb-4 col-12">
                                    <label for="email" class="font-medium">Email</label>
                                    <input id="email" type="email" [(ngModel)]="email" pInputText autocomplete="email">
                                  </div>
                                  @if (!EmailValid) {
                                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an email address.</div>
                                  }
                                  @if (!EmailFormatValid) {
                                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid email address.</div>
                                  }
                                </div>
                              }
                              @if (ProvideMinimalPersonalData == 'FULL' || ProvideMinimalPersonalData == 'LIMITED') {
                                <div style="width:100%">
                                  <div class="field mb-4 col-12">
                                    <label for="mobile" class="font-medium">Mobile</label>
                                    <input id="mobile" type="tel" pattern="^\+?\d{1,3}?[\s\-]?(\(?\d{1,4}\)?[\s\-]?)?[\d\s\-]{5,}$" [(ngModel)]="mobile" pInputText autocomplete="mobile">
                                  </div>
                                  @if (!MobileValid) {
                                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a mobile number.</div>
                                  }
                                  @if (!MobileFormatValid) {
                                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid mobile number.<div style="clear:both;"></div></div>
                                  }
                                </div>
                              }
                              <div style="clear:both;width: 100%;height: 20px;"></div>
                              <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneCustomer()">
                                <span>Add this Customer</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                              </button>
                            </div>
                          </div>
                        }
                      </app-accordiontab>
                      <app-accordiontab [(selected)]="notesSelected" [disabled]="notesActive">
                        <ng-template pTemplate="header">
                          <div style="width:100%">
                            <span class="pi pi-envelope" style="margin-right: 10px;"></span> Notes
                          </div>
                        </ng-template>
                        <div class="surface-card p-4 shadow-2 border-round">
                          <div class="grid formgrid p-fluid">
                            <div class="field mb-4 col-12">
                              <label for="notesName" class="font-medium">Notes</label>
                              <textarea pTextarea [(ngModel)]="NewBooking.notes" id="notesName" type="text" ></textarea>
                            </div>
                          </div>
                          <div style="clear:both;">
                            <button pButton type="button" style="height: 50px; width: 155px;margin-top:20px;" class="p-button p-button" (click)="doneNotes()">
                              <span>Next</span>
                              <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                            </button> &nbsp;
                          </div>
                        </div>
                      </app-accordiontab>
                      <app-accordiontab [(selected)]="paymentSelected" [disabled]="paymentActive">
                        <ng-template pTemplate="header">
                          <div style="width:100%">
                            <span class="pi pi-money-bill" style="margin-right: 10px;"></span> {{PaymentHeader}}
                          </div>
                        </ng-template>
                        <div class="surface-card p-4 shadow-2 border-round">
                          <div class="grid formgrid p-fluid">
                            <div style="font-weight:bold; font-size:20px; margin-bottom:20px;">
                              Value of Booking: {{(NewBooking.totaladmissions) |  currency:CurrencySymbol}}
                              @if (NewBooking.totaldiscounts > 0) {
                                <span>(- Discount: {{NewBooking.totaldiscounts | currency:CurrencySymbol}})</span>
                              }
                              @if (NewBooking.totalbookingfees> 0) {
                                <span> + Booking Fee: {{NewBooking.totalbookingfees | currency:CurrencySymbol}}</span>
                              }
                              @if (NewBooking.totalextras> 0) {
                                <span> + Extras Value: {{NewBooking.totalextras | currency:CurrencySymbol}}</span>
                              }
                              @if (NewBooking.totalupgrades> 0) {
                                <span> + Upgrades Value: {{NewBooking.totalupgrades | currency:CurrencySymbol}}</span>
                              }
                              <span> (Total Value: {{(NewBooking.total) | currency:CurrencySymbol}})</span>
                            </div>
                            @if (BookingPayments.length > 0) {
                              <div class="surface-card p-4 shadow-2 border-round" style="width:100%; margin-bottom: 20px;">
                                <label for="extras" class="font-medium">Payments already made</label>
                                <div>
                                  <p-table [value]="BookingPayments">
                                    <ng-template #header>
                                      <tr>
                                        <th></th>
                                        <th style="width:90%">Date</th>
                                        <th style="width:10%">Method</th>
                                        <th style="width:20%">Amount</th>
                                      </tr>
                                    </ng-template>
                                    <ng-template #body let-payment let-index>
                                      <tr>
                                        <td></td>
                                        <td>{{payment.paymentDate | date:'dd/MM/yyyy'}}</td>
                                        <td>{{payment.method}}</td>
                                        <td>{{(payment.amount) | currency:CurrencySymbol}}</td>
                                      </tr>
                                    </ng-template>
                                    <ng-template #footer>
                                      <tr>
                                        <td></td>
                                        <td>&nbsp;</td>
                                        <td>Total:</td>
                                        <td>{{totalPayments | currency:CurrencySymbol}}</td>
                                      </tr>
                                    </ng-template>
                                  </p-table>
                                </div>
                                @if (NewBooking.payments == null) {
                                  <div>
                                    No payments have been made against this booking
                                  </div>
                                }
                              </div>
                            }
                            <div class="field mb-4 col-12">
                              <label for="venueclosingname" class="font-medium">Payment Value</label>
                              <p-inputnumber [(ngModel)]="validPaymentAmount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputnumber>
                            </div>
                            @if (!paymentValueValid) {
                              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a payment amount.</div>
                            }
                            @if (!paymentValueExceededValid) {
                              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You cannot pay more than the booking value.</div>
                            }
                            @if (!paymentDepositValid) {
                              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Your payment must be at least {{MinimumValidPayment | currency:CurrencySymbol}}.</div>
                            }
                            <!--<div class="field mb-4 col-12">
                            <label for="paymentType" class="font-medium">Payment Type</label>
                            <p-select [options]="PaymentTypes" [(ngModel)]="selectedPayment" optionLabel="name" placeholder="Select a Type" [showClear]="true"></p-select>
                          </div>
                          <div *ngIf="!paymentTypeValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a payment type.</div>-->
                        </div>
                        @if (showDiscount) {
                          <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                            <div class="field mb-4 col-12">
                              <p-selectbutton id="allergy" [style]="{'width': '100%', 'max-width' : '430px', 'margin-bottom' : '20px'}" [options]="stateOptionOpenDiscount" [(ngModel)]="openDiscount"></p-selectbutton>
                              @if (openDiscount) {
                                <div>
                                  <label for="discountCode" class="font-medium">Enter Discount Amount</label><br>
                                  <p-inputnumber [(ngModel)]="chosenDiscountAmount" max="{{validPaymentAmount}}" min="0.01"  mode="currency" currency={{CurrencySymbol}} ></p-inputnumber>
                                </div>
                              }
                              @if (!openDiscount) {
                                <div>
                                  <label for="discountCode" class="font-medium">Enter Discount Code</label><br>
                                  <input id="discountCode" [(ngModel)]="discountCode" pInputText>
                                </div>
                              }
                            </div>
                            @if (openDiscount) {
                              <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneOpenDiscount()">
                                <span>Apply Discount</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                              </button>
                            }
                            @if (!openDiscount) {
                              <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneDiscount()">
                                <span>Apply Discount</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                              </button>
                            }
                          </div>
                        }
                        @if (showVoucher) {
                          <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                            <div class="field mb-4 col-12" style="float:left;">
                              <label for="voucherCode" class="font-medium">Enter Gift Voucher</label><br>
                              <input id="voucherCode" [(ngModel)]="voucherCode" pInputText>
                              <br>
                                <label for="voucherPIN" class="font-medium">Enter PIN</label><br>
                                <input id="voucherPIN" [(ngModel)]="voucherpin" pInputText [maxlength]="4" type="password">
                                <div style="clear:both; width:100%"></div>
                              </div>
                              <div>
                                <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneVoucher()">
                                  <span>Apply</span>
                                </button>
                              </div>
                              <div style="clear:both; width:100%"></div>
                            </div>
                          }
                          @for (p of PaymentTypes; track p) {
                            <button [disabled]="paymentButtonLocked" pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button" (click)="donePayment(p.id, p.name)">
                              @if (p.name=='Cash' && CurrencySymbol=='GBP') {
                                <span class="pi pi-pound" style="margin-right:8px;"></span>
                              }
                              @if (p.name=='Cash' && CurrencySymbol=='USD') {
                                <span class="pi pi-dollar" style="margin-right:8px;"></span>
                              }
                              @if (p.name=='Cash' && CurrencySymbol=='EUR') {
                                <span class="pi pi-euro" style="margin-right:8px;"></span>
                              }
                              @if (p.name=='Cash' && CurrencySymbol=='AUD') {
                                <span class="pi pi-dollar" style="margin-right:8px;"></span>
                              }
                              @if (p.name=='Card') {
                                <span class="pi pi-credit-card" style="margin-right:8px;"></span>
                              }
                              @if (p.name!='Cash' && p.name!='Card') {
                                <span class="pi pi-money-bill" style="margin-right:8px;"></span>
                              }
                              <span>Pay With {{p.name}}</span>
                            </button>
                          }
                          @if (!showDiscount) {
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayDiscount()">
                              <span class="pi pi-arrow-circle-down" style="margin-right:8px;"></span>
                              <span>Enter Discount</span>
                            </button>
                          }
                          @if (showDiscount) {
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayDiscount()">
                              <span class="pi pi-arrow-circle-left" style="margin-right:8px;"></span>
                              <span>Hide Discount</span>
                            </button>
                          }
                          @if (!showVoucher) {
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayVoucher()">
                              <span class="pi pi-ticket" style="margin-right:8px;"></span>
                              <span>Enter Gift Voucher</span>
                            </button>
                          }
                          @if (showVoucher) {
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-success" (click)="displayVoucher()">
                              <span class="pi pi-ticket" style="margin-right:8px;"></span>
                              <span>Hide Gift Voucher</span>
                            </button>
                          }
                          @if (NewBooking.discounts) {
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-danger" (click)="removeDiscount()">
                              <span class="pi pi-arrow-circle-up" style="margin-right:8px;"></span>
                              <span>Remove Discount</span>
                            </button>
                          }
                          <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-danger" (click)="deferPayment()">
                            <span class="pi pi-clock" style="margin-right:8px;"></span>
                            <span>Defer Payment</span>
                          </button>
                          <br>
                            @if (!showDiscount && qbook!='true') {
                              <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;margin-bottom:10px;" class="p-button p-button-warn" (click)="sendPaymentLink()">
                                <span class="pi pi-envelope" style="margin-right:8px;"></span>
                                <span>Send Payment Link</span>
                              </button>
                            }
                          </div>
                        </app-accordiontab>
                      </app-accordion>
                    </div>
                  }
                </div>
              }
              @if (BookingComplete) {
                <div>
                  <div class="p-3 flex flex-column flex-auto">
                    <h3 style="margin-bottom:20px;" i18n>Booking Summary</h3>
                    @if (BookingSummary) {
                      <div>
                        <div style="width:100%; margin-bottom: 15px;">
                          <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Sales ID</b> : {{BookingSummary.bookingIdHR}}
                        </div>
                        <div style="width:100%; margin-bottom: 15px;">
                          <span class="pi pi-calendar" style="margin-right: 10px;"></span>
                          <b>Start Date/Time</b> : {{BookingSummary.startTime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}
                        </div>
                        <div style="width:100%; margin-bottom: 15px;">
                          <span class="pi pi-user" style="margin-right: 10px;"></span>
                          <b>Customer</b> : {{BookingSummary.customerAddress}}
                        </div>
                        <div style="width:100%; margin-bottom: 15px;">
                          <span class="pi pi-box" style="margin-right: 10px;"></span>
                          <b>Package</b> : {{BookingSummary.packageName}}
                        </div>
                        <div style="width:100%; margin-bottom: 15px;">
                          <span class="pi pi-users" style="margin-right: 10px;"></span>
                          <b>Admissions</b> : {{BookingSummary.admissions}}
                        </div>
                        @if (BookingSummary.upgrade != '') {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-arrow-up" style="margin-right: 10px;"></span>
                            <b>Upgrade</b> : {{BookingSummary.upgradetext}}
                          </div>
                        }
                        @if (BookingSummary.upgrade != '') {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-arrow-circle-up" style="margin-right: 10px;"></span>
                            <b>Add-Ons</b> : {{BookingSummary.addontext}}
                          </div>
                        }
                        @if (BookingSummary.extras != '') {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-star" style="margin-right: 10px;"></span>
                            <b>Extras</b> : {{BookingSummary.extras}}
                          </div>
                        }
                        @if (BookingSummary.totalbookingfees > 0) {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-pound" style="margin-right: 10px;"></span>
                            <b>Booking Fee</b> : {{BookingSummary.totalbookingfees | currency:CurrencySymbol }}
                          </div>
                        }
                        <div style="width:100%; margin-bottom: 15px;">
                          <span class="pi pi-pound" style="margin-right: 10px;"></span>
                          <b>Sales Value</b> : {{BookingSummary.total | currency:CurrencySymbol }}
                        </div>
                        @if (BookingSummary.totaldiscounts > 0) {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-pound" style="margin-right: 10px;"></span>
                            <b>Discounts</b> : {{BookingSummary.totaldiscounts | currency:CurrencySymbol }}
                          </div>
                        }
                        @if (BookingSummary.outstanding > 0) {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-pound" style="margin-right: 10px;"></span>
                            <b>Paid</b> : <span>{{BookingSummary.paid | currency:CurrencySymbol }}</span>
                          </div>
                        }
                        @if (BookingSummary.outstanding <= 0) {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-pound" style="margin-right: 10px;"></span>
                            <b>Paid</b> : {{BookingSummary.paid | currency:CurrencySymbol }}
                          </div>
                        }
                        @if (BookingSummary.outstanding > 0) {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-pound" style="margin-right: 10px;"></span>
                            <b>Outstanding</b> : <span style="color: red; font-weight: bold;">{{BookingSummary.outstanding | currency:CurrencySymbol }}</span>
                          </div>
                        }
                        @if (BookingSummary.outstanding <= 0) {
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-pound" style="margin-right: 10px;"></span>
                            <b>Outstanding</b> : {{BookingSummary.outstanding | currency:CurrencySymbol }}
                          </div>
                        }
                        <div style="width:100%; margin-bottom: 15px;">
                          @if (SummaryItinerary) {
                            <div>
                              <span class="pi pi-list" style="margin-right: 10px;"></span><b>Itinerary</b>:
                              <div style="margin-top:5px; margin-bottom:10px;">
                                <table [cellPadding]="3" >
                                  @for (itin of (NewBooking.itineraryEX); track itin) {
                                    <tr style="border-bottom: 1px solid #dddddd">
                                      <td>&nbsp;</td>
                                      <td>
                                        <b>{{itin.resource}}</b>
                                      </td>
                                      <td>
                                        {{itin.starttime}}
                                      </td>
                                      <td >
                                        {{itin.people}}&nbsp;people
                                      </td>
                                    </tr>
                                  }
                                  <tr style="border-bottom: 1px solid #dddddd">
                                    <td>&nbsp;</td>
                                    <td>
                                      <b>End:</b>
                                    </td>
                                    <td>
                                      {{addMs(BookingSummary.endTime, 1)| date:'HH:mm' : 'UTC'}}
                                    </td>
                                    <td>&nbsp;</td>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          }
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-envelope" style="margin-right: 10px;"></span><b>Email</b> : {{BookingSummary.customerEmail}}
                            <button pButton type="button" style="height: 25px; margin-right: 5px;width: 25px; float:right;" class="p-button-sm p-element p-ripple p-button p-component" (click)="sendanemail(bookingFromClick.bookingdata.bookingid)">
                              <span class="pi pi-envelope" style="margin-left: -8px; font-size: 15px;"></span>
                            </button>
                          </div>
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-mobile" style="margin-right: 10px;"></span><b>Mobile</b> : {{BookingSummary.customerMobile}}
                            <button pButton type="button" style="height: 25px; margin-right: 5px;width: 25px; float:right;" class="p-button-sm p-element p-ripple p-button p-component" (click)="makeacall(bookingFromClick.bookingdata.bookingid)">
                              <span class="pi pi-mobile" style="margin-left: -8px; font-size: 15px;"></span>
                            </button>
                          </div>
                          <div style="width:100%; margin-bottom: 15px;">
                            <span class="pi pi-file" style="margin-right: 10px;"></span><b>Notes</b> : {{BookingSummary.notes}}
                          </div>
                        </div>
                      </div>
                    }
                    <!--<div class="surface-card p-4 shadow-2 border-round">-->
                    <!-- An even gap between the buttons, however many of them show. -->
                    <div style="margin-top: 25px; display: flex; flex-wrap: wrap; gap: 8px;">
                      @if (BookingSummary.customerEmail != '') {
                        <button pButton pRipple type="button" class="p-button-success p-element p-button w-auto mt-3" (click)="sendEmailConfirmation()">
                          <span class="pi pi-envelope" style="margin-right:8px;"></span>
                        Send Confirmation Email</button>
                      }
                      @if (BookingSummary.customerMobile != '') {
                        <button disabled="true" pButton pRipple type="button" class="p-button-success p-element p-button w-auto mt-3" (click)="sendSMSConfirmation()">
                          <span class="pi pi-mobile" style="margin-right:8px;"></span>
                        Send Confirmation Text</button>
                      }
                      <button pButton pRipple type="button" class="p-button-info p-element p-button w-auto mt-3" (click)="printConfirmation()">
                        <span class="pi pi-print" style="margin-right:8px;"></span>
                      Print Confirmation</button>
                      @if (qbook!='true') {
                        <button pButton pRipple type="button" class="p-button p-element p-button w-auto mt-3" (click)="returnHome()">
                          <span class="pi pi-calendar-plus" style="margin-right:8px;"></span>
                        Make Another Booking</button>
                      }
                      @if (qbook=='true') {
                        <button pButton pRipple type="button" class="p-button p-element p-button w-auto mt-3" (click)="returnQHome()">
                          <span class="pi pi-calendar-plus" style="margin-right:8px;"></span>
                        Make Another Quick Booking</button>
                      }
                      @if (Checkfortoday() && qbook!='true') {
                        <button pButton pRipple type="button" class="p-button p-button-success p-element p-button w-auto mt-3" (click)="admitall()">
                          <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                        Admit this Booking</button>
                      }
                      @if (Checkfortoday() && qbook=='true') {
                        <button pButton pRipple type="button" class="p-button p-button-success p-element p-button w-auto mt-3" (click)="admitAndReturn()">
                          <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                        Admit this Booking</button>
                      }
                    </div>
                  </div>
                </div>
              }

